export const AccountHeadersModel = [
    {
        text: "Действия",
        value: "actions",
        sortable: false
    },
    {
        text: "Имя программы",
        value: "Campaign.name"
    },
    {
        text: "Счёт по дебиту (Счёт списания бонусов)",
        value: "AccountAccrual.Amount"
    },
    {
        text: "Счёт по кредиту (Счёт начисления бонусов)",
        value: "AccountEmission.Amount"
    },

]
